/**
 * Normaliza uma string para um formato amigável para URLs ou identificadores.
 *
 * Esta função realiza os seguintes passos:
 * 1. Substitui espaços em branco por underscores ('_').
 * 2. Remove acentuações e caracteres especiais, utilizando a normalização Unicode.
 * 3. Remove todos os caracteres que não sejam letras, números ou underscores.
 *
 * @param value A string de entrada que será normalizada.
 * @returns Uma nova string normalizada, sem espaços, acentuações e caracteres especiais.
 */
export function normalizeString(value: string) {
  // Substituir espaços por underscores
  let normalizedString = value.replace(/\s+/g, "_");

  // Remover acentuações usando `normalize` e regex
  normalizedString = normalizedString
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  // Remover caracteres especiais, mantendo apenas letras, números e underscores
  normalizedString = normalizedString.replace(/[^a-zA-Z0-9_]/g, "");

  return normalizedString.toLowerCase();
}
